import VideoModal from "src/components/VideoModal"
import { ModalWrapper } from "src/utils/fw"
import { modalColor } from "../utils"
import { assignAchievement } from "src/components/Leaderboard"
import { userID } from "src/utils/datalayer"
import { dismiss } from "./modals/HTEP"
import BoothPopup from "../components/BoothPopup"

export default {
    background: "https://assets.swoogo.com/uploads/full/4590323-672148bb9cf1b.png",
    links: [
        {
            label: "BlackDuck Logo",
            width: "21.5%",
            height: "10.7%",
            left: "12.5%",
            top: "50.4%",
            modalOverrides: dismiss,
            modal: <BoothPopup
                companyName="BlackDuck"
                companyUrl="https://www.blackduck.com/"
                image="https://assets.swoogo.com/uploads/medium/4485180-66fc4e08dfb98.png"
                room="silver-bronze"
                text="Black Duck® offers the most comprehensive, powerful, and trusted portfolio of application security solutions in the industry. We have an unmatched track record of helping organisations around the world secure their software quickly, integrate security efficiently in their development environments, and safely innovate with new technologies. As the recognised leaders, experts, and innovators in software security, Black Duck has everything you need to build trust in your software."
                socialMedia={[]}
            />
        },
        {
            label: "BlackDuck Video",
            modalOverrides: dismiss,
            modal: <ModalWrapper wrapperStyle={{
                background: modalColor,
                aspectRatio: "16 / 9",
                width: "50%",
                minWidth: "700px"
            }}>
                <VideoModal url="https://player.vimeo.com/video/1024785876?h=7f22a9b18b&autoplay=1" />
            </ModalWrapper>,
            onClick: () => {
                assignAchievement({
                    achievementId: "1ec5851c-92cf-4cf6-ba27-c7c7d19622bf",
                    eventId: "161759",
                    userId: userID
                })
            },
            width: "9.5%",
            height: "10.7%",
            left: "35.5%",
            top: "50.4%",
        },
        {
            label: "BlackDuck Contact Us",
            href: "mailto:nam_events@blackduck.com",
            target: "_blank",
            onClick: () => {
                assignAchievement({
                    achievementId: "16275f54-4e0e-4061-98a9-a234c1c80424",
                    eventId: "161759",
                    userId: userID
                })
            },
            isExternal: true,
            width: "10.5%",
            height: "15.7%",
            left: "32.6%",
            top: "74.4%",
        },
        {
            label: "BlackDuck PDF File",
            href: "https://assets.swoogo.com/uploads/4584726-671fc31658883.pdf",
            onClick: () => {
                assignAchievement({
                    achievementId: "1ec5851c-92cf-4cf6-ba27-c7c7d19622bf",
                    eventId: "161759",
                    userId: userID
                })
            },
            target: "_blank",
            width: "5.5%",
            height: "23.7%",
            left: "8%",
            top: "64.4%",
        },
        {
            label: "Illumio Logo",
            width: "16.5%",
            height: "10.7%",
            left: "36%",
            top: "16.4%",
            modalOverrides: dismiss,
            modal: <BoothPopup
                companyName="Illumio"
                companyUrl="https://www.illumio.com"
                image="https://assets.swoogo.com/uploads/medium/4570532-6719510e0cb97.png"
                room="silver-bronze"
                text={<>
                    <p>Illumio, the Zero Trust Segmentation company, stops breaches and ransomware from spreading across the hybrid attack surface.</p>
                    <p>The Illumio ZTS Platform visualises all communication and traffic between workflows, devices, and the internet in one console, automatically sets granular segmentation policies to control unnecessary and unwanted communications and isolates high-value assets and compromised systems to proactively or reactively stop the spread of a breach.</p>
                    <p>ZTS is proven to help organisations of all sizes, from Fortune 100 to small business, stop breaches and ransomware in minutes, save millions in application downtime, and accelerate digital transformation projects.</p>
                    <p>Assume breach. Minimize impact. Increase resilience.</p>
                </>}
                socialMedia={[]}
            />
        },
        {
            label: "Illumio Video",
            modalOverrides: dismiss,
            modal: <ModalWrapper wrapperStyle={{
                background: modalColor,
                aspectRatio: "16 / 9",
                width: "50%",
                minWidth: "700px"
            }}>
                <VideoModal url="https://player.vimeo.com/video/1024785935?h=60977b7441&autoplay=1" />
            </ModalWrapper>,
            onClick: () => {
                assignAchievement({
                    achievementId: "9fdb9c88-bf48-44f9-917e-2dbbb606dcd1",
                    eventId: "161759",
                    userId: userID
                })
            },
            width: "9.5%",
            height: "10.7%",
            left: "55%",
            top: "16.4%",
        },
        {
            label: "Illumio PDF File",
            href: "https://assets.swoogo.com/uploads/4585634-671feacf58ba5.pdf",
            onClick: () => {
                assignAchievement({
                    achievementId: "151306f5-753e-4b48-9d7a-6a3a6b8afa19",
                    eventId: "161759",
                    userId: userID
                })
            },
            isExternal: true,
            width: "4.5%",
            height: "17.7%",
            left: "30%",
            top: "25%",
        },
        {
            label: "Illumio Contact Us",
            href: "mailto:Charles.Johnson@illumio.com",
            target: "_blank",
            isExternal: true,
            onClick: () => {
                assignAchievement({
                    achievementId: "fa806daa-f4ce-4524-a55c-32918d7bc3dd",
                    eventId: "161759",
                    userId: userID
                })
            },
            width: "9.5%",
            height: "10.7%",
            left: "61%",
            top: "32.4%",
        },
        {
            label: "DataBee Logo",
            width: "21.5%",
            height: "10.7%",
            left: "67.5%",
            top: "50.4%",
            modalOverrides: dismiss,
            modal: <BoothPopup
                companyName="DataBee"
                companyUrl="https://databee.buzz/"
                image="https://assets.swoogo.com/uploads/medium/4485242-66fc5033db89e.png"
                room="silver-bronze"
                text="Databee from Comcast Technology Solutions is an enterprise-ready security, risk, and compliance data fabric platform that helps you become more secure, compliant, and ready for what’s next. The data transformation and content engine transforms your security data to Open Cybersecurity Schema Framework (OCSF) and connects related insights to give your team business-relevant context they understand. Drive better and smarter decisions with analysis-ready datasets and an evidence-centric approach to security data."
                socialMedia={[]}
            />
        },
        {
            label: "DataBee Video",
            modalOverrides: dismiss,
            modal: <ModalWrapper wrapperStyle={{
                background: modalColor,
                aspectRatio: "16 / 9",
                width: "50%",
                minWidth: "700px"
            }}>
                <VideoModal url="https://player.vimeo.com/video/1024785913?h=140d2f062b&autoplay=1" />
            </ModalWrapper>,
            onClick: () => {
                assignAchievement({
                    achievementId: "fb0bcd4b-e230-46c5-b761-6cb3e10ddb78",
                    eventId: "161759",
                    userId: userID
                })
            },
            width: "9.5%",
            height: "10.7%",
            left: "55.5%",
            top: "50.4%",
        },
        {
            label: "DataBee Contact Us",
            href: "mailto:lina_imbrusaite@comcast.com",
            target: "_blank",
            onClick: () => {
                assignAchievement({
                    achievementId: "8821e145-b404-439a-882b-8b298740100b",
                    eventId: "161759",
                    userId: userID
                })
            },
            isExternal: true,
            width: "10.5%",
            height: "15.7%",
            left: "57.4%",
            top: "74.4%",
        },
        {
            label: "DataBee PDF File",
            href: "https://assets.swoogo.com/uploads/4585651-671febca35118.pdf",
            onClick: () => {
                assignAchievement({
                    achievementId: "add74e9f-3370-48f1-a1ea-c3ce46de1191",
                    eventId: "161759",
                    userId: userID
                })
            },
            
            target: "_blank",
            width: "5.5%",
            height: "23.7%",
            left: "87%",
            top: "64.4%",
        },
        {
            label: "Back to Exhibition Hall",
            href: "/exhibition-hall",
            width: "14.3%",
            height: "8%",
            left: "44.9%",
            top: "89.4%",
        }
    ],
    name: "exhibition-hall-silver-bronze",
}